import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const main = defineStyle({
  tab: {
    color: 'rentals.primary.txt',
    borderBottom: '3.5px solid',
    borderColor: 'transparent',

    _selected: { borderColor: 'rentals.primary.txt' },
    _active: { backgroundColor: 'gray.300' },
  },
  tablist: { borderBottom: '1px solid', borderColor: '#9F9DB0' },
});

const Tabs = defineStyleConfig({
  variants: { main },
  defaultProps: { variant: 'main' },
});

export default Tabs;
